<template>
  <div
    class="requisition-report-widget-comments-composer"
    :class="{ 'd-flex justify-center': isCordLoading }"
  >
    <div
      v-if="isCordLoading"
      class="d-flex flex-column justify-center"
    >
      <v-progress-circular
        indeterminate
        color="brandPrimary"
        size="40"
      />
    </div>

    <div v-else>
      <cord-composer
        :location="JSON.stringify(threadLocation)"
        :thread-metadata="JSON.stringify(threadMetaData)"
        :thread-name="threadName"
        size="medium"
        show-close-button="true"
        show-expanded="true"
        @cord-composer:close="$emit('close', $event)"
        @cord-composer:send="$emit('messageSend', $event)"
      />
    </div>
  </div>
</template>

<script>
import { useCommenting } from '@/stores/commenting/commenting';

export default {
  name: 'RequisitionReportWidgetCommentsToggle',

  props: {
    reqId: { type: String, default: '' },
    reqUuid: { type: String, default: '' },
    widgetId: { type: String, default: '' },
    threadName: { type: String, default: '' },
  },

  computed: {
    isCordLoading() {
      return useCommenting().isCordLoading;
    },
    threadLocation() {
      return { page: 'requisition-report', id: this.reqUuid };
    },
    threadMetaData() {
      return { reqUuid: this.reqUuid, reqId: this.reqId || '', widgetId: this.widgetId };
    },
  },

  mounted() {
    return useCommenting().loadCord();
  },
};
</script>

<style scoped lang="less">
.requisition-report-widget-comments-composer {
  text-align: initial;
  background: @white;
  min-width: 400px;
  min-height: 110px;
}
</style>
